<template>
    <div class="help-center-manual">
        <i class="fa fa-download download-button" @click="$uiUtils.openNewWindow(manual.fileUrl)" />

        <div>
            <span class="tutorials-manual-heading">{{ manual.title }}</span>
            <span class="tutorials-manual-description">{{ manual.description }}</span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'HelpCenterManual',
    props: {
        manual: {
            type: Object,
            required: true
        }
    }
}
</script>

<style lang="scss" scoped>
.help-center-manual {
    position: relative;
    padding: 3rem;
    text-align: center;
    display: grid;
    place-items: center;

    &:nth-child(5n + 1) {
        background: #32a099;
    }
    &:nth-child(5n + 2) {
        background: #461377;
    }
    &:nth-child(5n + 3) {
        background: #2670b7;
    }
    &:nth-child(5n + 4) {
        background: #2d2e82;
    }
    &:nth-child(5n + 5) {
        background: #379fe5;
    }

    @media screen and #{$new-break3close} {
        min-height: 15rem;
    }
    @media screen and #{$new-break4open} {
        min-height: 20rem;
    }

    .download-button {
        cursor: pointer;
        position: absolute;
        top: 1.5rem;
        right: 1.5rem;
        font-size: 2rem;
    }

    .tutorials-manual-heading,
    .tutorials-manual-description {
        font-size: 1.25rem;
    }

    .tutorials-manual-description {
        @include text-ellipsis-multiline();
    }
}
</style>
